require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-introducing-sian-teasdale.json") })
        }
      }, "path---authors-introducing-sian-teasdale");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-introducing-sian-teasdale!./.cache/json/authors-introducing-sian-teasdale.json
// module id = 1292
// module chunks = 231608221292675